let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
import computeTourSteps from '../core/steps'
import { renderDialogHtml, updateDialogHtml } from '../core/dialog'
import waitForElm from '../util/util_wait_for_element'
/**
 * handleRefreshTour
 */
function handleRefreshTour() {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        /**
         * Tour steps
         */
        yield computeTourSteps(this).catch(e => {
          return reject(e)
        })
        /**
         * Backdrop
         */
        this.computeBackdropAttributes()
        /**
         * Dialog
         */
        yield this.refreshDialog().catch(e => {
          return reject(e)
        })
        return resolve(true)
      })
    )
  })
}
/**
 * handleRefreshDialog
 */
function handleRefreshDialog() {
  return __awaiter(this, void 0, void 0, function*() {
    return new Promise((resolve, reject) =>
      __awaiter(this, void 0, void 0, function*() {
        /**
         * Hard refresh dialog HTML - for option updates or hard refresh methods
         */
        yield renderDialogHtml(this)
          .then(htmlResp => {
            if (htmlResp) this.dialog.innerHTML = htmlResp
          })
          .catch(e => {
            if (this.options.debug) console.warn(e)
          })
        /**
         * Update tour guide HTML
         */
        yield updateDialogHtml(this).catch(e => {
          if (this.options.debug) console.warn(e)
          reject(e)
        })
        /**
         * Update backdrop & dialog positions & display
         */
        yield this.updatePositions()
        /**
         * Ensure dialog is visible & rendered in DOM
         */
        if (this.isVisible)
          yield waitForElm('.tg-dialog').then(() =>
            __awaiter(this, void 0, void 0, function*() {
              /**
               * Re-Init listeners
               * Double initialization is handled inside of handler
               */
              yield this.destroyListeners()
              yield this.initListeners()
              // Add transition class to dialog after additional delay to prevent flying in from random position
              // if (this.options.dialogAnimate) setTimeout(() => {
              //     this.dialog.classList.add('animate-position')
              // }, 600)
              return true
            })
          )
        return resolve(true)
      })
    )
  })
}
export default handleRefreshTour
export { handleRefreshDialog }
